var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t-result"},[_c('div',[_c('img',{style:(_vm.imgStyle),attrs:{"alt":_vm.text,"src":_vm.iImage}}),_c('p',{staticClass:"t-text"},[_vm._v(_vm._s(_vm.iText))])]),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }